export const RunStates = {
  NOT_RUN: 'Not run',
  RUNNING: 'Running',
  CONTINUING: 'Continuing',
  COMPLETE: 'Complete',
  TIMED_OUT: 'Timed out',
  FAILED: 'Failed',
  UPDATE_COMPLETE: 'Update complete'
}
